























































import CoPaywall from '@/components/Organisms/co-paywall/CoPaywall.vue';

export default {
    name: 'IntegrationsList',
    components: { CoPaywall },
    data() {
        return {};
    },
    computed: {
        isFreePlan() {
            const space = this.$store && this.$store.state && this.$store.state.space;
            return space && space.PlanSlug === 'free';
        },
    },
    methods: {
        showPaywall() {
            const paywall = this.$refs.paywall;
            if (paywall?.show) {
                paywall.show();
            }
        },
    },
};
